import { ITenant } from "@/types/tenant";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface TenantState {
  tenant: ITenant | null;
}

const initialState: TenantState = {
  tenant: null,
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenant: (state, { payload }: PayloadAction<ITenant | null>) => {
      return {
        ...state,
        tenant: payload,
      };
    },
  },
});

export const { setTenant } = tenantSlice.actions;
export const { reducer: tenantReducer } = tenantSlice; 